





































import {Component, Vue} from 'vue-property-decorator';
const bigInt = require('big-integer');

import freqList from '@/base3000.json'
import {BigInteger} from 'big-integer';

@Component
export default class App extends Vue
{
    input: string = '90000270170';
    output: string = '三千进制';

    onInputChange()
    {
        this.input = this.input.replace(/[^\d]/g, '');
        this.output = this.input ? this.encode(bigInt(this.input)) : '';
    }

    onOutputChange()
    {
        // Typing
        if (this.isTyping(this.output))
        {
            this.input = 'Typing... (Chinese chars only on the right side)';
            return;
        }

        // Check letters existence
        this.output = this.output.split('').filter(c => freqList.includes(c)).join('');

        this.input = this.decode(this.output).toString();
    }

    /**
     * Encode base 3000
     *
     * @param value
     * @param scheme Letter scheme used
     */
    encode(value: BigInteger, scheme = freqList)
    {
        const base = scheme.length;
        let result = '';

        while (!value.eq(0))
        {
            // Calculate the dec digit
            const digit = value.mod(base).toJSNumber();

            // Find char from digit and add to result
            result = scheme[digit] + result;

            // Update value
            value = value.subtract(digit).divide(base);
        }

        return result || scheme[0];
    }

    /**
     * Decode Base 3000
     *
     * @param value
     * @param scheme Letter scheme used
     */
    decode(value: string, scheme = freqList)
    {
        const base = scheme.length;

        return value.split('').reverse().reduce((sum, char, index) =>
        {
            // Find digit from char
            const digit = scheme.indexOf(char);

            // Not found scenario
            if (digit == -1) throw new Error(`未知字符 | Unknown Char: '${char}'`);

            // Add value to sum
            return sum.add(bigInt(digit).multiply(bigInt(base).pow(index)));
        }, bigInt.zero);
    }

    /**
     * Is typing with chinese IME or not
     *
     * @param str
     */
    isTyping(str: string)
    {
        const lower = str.toLowerCase();
        const english = 'abcdefghijklmnopqrstuvwxyz';

        return lower.split('').filter(c => english.includes(c)).length > 0;
    }
}
